import {
  FaBrain,
  FaCommentDots,
  FaFileImport,
  FaGear,
  FaKey,
  FaPython,
  FaSliders,
  FaUser,
  FaUsers,
} from 'react-icons/fa6';
import type { IconType } from 'react-icons';

export type SettingsSectionKey =
  | 'settings'
  | 'account'
  | 'users'
  | 'python-functions'
  | 'secrets'
  | 'files'
  | 'prompts'
  | 'models'
  | 'model-specifications';

type SettingsSection = {
  key: SettingsSectionKey;
  label: string;
  icon: IconType;
  requiresSuperuser?: boolean;
};

export const SETTINGS_SECTIONS: SettingsSection[] = [
  { key: 'settings', label: 'General', icon: FaGear },
  { key: 'account', label: 'Account', icon: FaUser },
  { key: 'users', label: 'Users', icon: FaUsers, requiresSuperuser: true },
  { key: 'python-functions', label: 'Python Functions', icon: FaPython },
  { key: 'secrets', label: 'Secrets', icon: FaKey },
  { key: 'files', label: 'Files', icon: FaFileImport },
  { key: 'prompts', label: 'Prompts', icon: FaCommentDots },
  { key: 'models', label: 'Models', icon: FaBrain },
  { key: 'model-specifications', label: 'Model Specifications', icon: FaSliders },
];

export const SETTINGS_SECTION_LABEL = Object.fromEntries(
  SETTINGS_SECTIONS.map((section) => [section.key, section.label]),
) as Record<SettingsSectionKey, string>;

export const isSettingsSection = (value: string | null): value is SettingsSectionKey =>
  value != null && SETTINGS_SECTIONS.some((s) => s.key === value);

export const getVisibleSettingsSections = (isSuperuser: boolean): SettingsSection[] =>
  SETTINGS_SECTIONS.filter((section) => !section.requiresSuperuser || isSuperuser);

export const isSettingsSectionVisible = (key: SettingsSectionKey, isSuperuser: boolean): boolean =>
  getVisibleSettingsSections(isSuperuser).some((section) => section.key === key);
